<template>
    <v-row class="grey" >
            <div class="d-flex px-5 py-2">
                <div class="text-h5">
                    Selected {{ GET_fireSelected.users.length }} of {{ GET_fireSelected.total}}
                <!-- {{ usersSelected.length }} of {{ computedTableData.length }} Selected<br /> -->
                </div>
            </div>
            <v-spacer />
            <!-- <div><appbutton :label="$t(`buttons.viewSelected`)" v-if="JSON.stringify(usersSelected) !== '[]'" icon="icons8-checkmark-yes" type="black"  class="mr-0" @click.native="viewSelected = !viewSelected" showlabel="xsOnly" /></div> -->
    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        computed: {
            ...mapGetters({
                GET_fireSelected: 'fireSelected_store/GET_fireSelected',
            }),
        }
    }
</script>